import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig, AppConfiguration } from 'src/configuration';
import { BaseService } from './base.service';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PhieuDanhGiaGuiService   extends BaseService{
 
  constructor(
    @Inject(AppConfig) private readonly appConfig: AppConfiguration,
    private http: HttpClient
  ) {
    super();
  }

  getPhieuDanhGiaGui(token): Observable<any> {
    return this.http
      .get<any>(this.appConfig.SurveyURL + "phan-phoi-giang-vien/get-phieu-da-gui", {
        headers: new HttpHeaders()
          .set("Authorization", `Bearer ${token}`)
          .set("Access_code", this.access_code),
      })
      .pipe(
        catchError(this.handleError),
        map((z) => {
          return z;
        })
      );
  }

  insertDotDanhGiaGui(data: any, token): Observable<any> {
    return this.http
      .post<any>(this.appConfig.SurveyURL + "phan-phoi-giang-vien/insert-dot-danh-gia-gui", data, {
        headers: new HttpHeaders()
          .set("Authorization", `Bearer ${token}`)
          .set("Access_code", this.access_code),
      })
      .pipe(
        catchError(this.handleError),
        map((z) => {
          return z;
        })
      );
  }
}
